//import "./public-app.scss";
import { Button } from "@blueprintjs/core";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import "@blueprintjs/popover2/lib/css/blueprint-popover2.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { changeLanguage, t } from "i18next";
import "normalize.css/normalize.css";
import React from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";

import { DialogRoot, FullPageLoader } from "./components";
import { AppError } from "./components/AppError";
import { useCommonHooks, useLanguages } from "./hooks";
import { ETLCodes } from "./locales";
import { PublicAppRouter } from "./PublicAppRouter";
import { PublicLoginRouter } from "./PublicLoginRouter";
const AppContainer = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  flex-direction: column;
  padding: 1rem;
`;

const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: 100%;
  flex-wrap: wrap;
`;

export interface PublicAppProps {}

export const PublicApp: React.FC<PublicAppProps> = ({}) => {
  const { isLoggedIn, authLoading, globalDataLoading, currentLanguage } =
    useCommonHooks();

  const { changeLanguage } = useLanguages();

  const appIsLoading = React.useMemo(
    () => globalDataLoading || authLoading,
    [globalDataLoading, authLoading]
  );

  const listenToPopstate = React.useCallback(() => {
    const winPath = window.location.href;
    console.log("winpath", winPath);
    if (winPath.includes("/fr/")) {
      console.log("changing to FR");
      changeLanguage("fr");
    } else if (winPath.includes("/nl/")) {
      console.log("changing to NL");
      changeLanguage("nl");
    }
  }, [changeLanguage]);
  React.useEffect(() => {
    window.addEventListener("popstate", listenToPopstate);
    return () => {
      window.removeEventListener("popstate", listenToPopstate);
    };
  }, [listenToPopstate]);

  React.useEffect(() => {
    listenToPopstate();
  }, [listenToPopstate]);

  if (appIsLoading) {
    return <FullPageLoader fullHeight={false} />;
  }

  return (
    <AppContainer style={{ width: "100%" }}>
      <AppError>
        <ContentContainer className="page">
          {isLoggedIn ? <PublicAppRouter /> : <PublicLoginRouter />}
        </ContentContainer>
      </AppError>
      <DialogRoot />
    </AppContainer>
  );
};
